__turbopack_context__.v({
  "button": "AfishaTag-module-sass-module__sv-gtG__button",
  "icon": "AfishaTag-module-sass-module__sv-gtG__icon",
});
